import { ChatMessage, PhysioChatMessage } from "shared-interfaces";

/**
 * Type guard to determine if object is PhysioChatMessage
 * @param message
 */
export const isPhysioMessage = (message: Partial<ChatMessage>): message is PhysioChatMessage => {
  return !!(message as PhysioChatMessage).staffId;
};